"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unique = exports.capitalize = exports.chunk = exports.toNumber = exports.hasOwnProperty = exports.shortCircuit = exports.asyncFind = exports.asyncForEachMap = exports.asyncForEach = void 0;
/**
 * Executes an async callback for each item in an array.
 */
async function asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
}
exports.asyncForEach = asyncForEach;
/**
 * Executes an async callback for each item in a Map.
 */
async function asyncForEachMap(map, callback) {
    for (let [key, value] of map) {
        await callback(value, key, map);
    }
}
exports.asyncForEachMap = asyncForEachMap;
/**
 * Iterates an array, and returns the first element for which the async callback
 * returns true.
 */
async function asyncFind(array, callback) {
    let match;
    for (let index = 0; index < array.length; index++) {
        if ((await callback(array[index], index, array)) === true) {
            match = array[index];
            break;
        }
    }
    return match;
}
exports.asyncFind = asyncFind;
/**
 * Iterates an array, and returns the first element for which the predicate
 * returns a value.
 */
function shortCircuit(input, predicate) {
    let output;
    input.some((value, index, array) => !!(output = predicate(value, index, array)));
    return output;
}
exports.shortCircuit = shortCircuit;
// https://fettblog.eu/typescript-hasownproperty/
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
exports.hasOwnProperty = hasOwnProperty;
/**
 * Casts a value to a number. Throws if this is not possible.
 */
function toNumber(value) {
    const number = Number(value);
    if (!Number.isFinite(number)) {
        throw new Error('Not a number');
    }
    return number;
}
exports.toNumber = toNumber;
/**
 * Splits an array in chunks of a certain size.
 */
function chunk(array, size) {
    return array.reduce((chunked, item, index) => {
        const chunkIndex = Math.floor(index / size);
        if (!chunked[chunkIndex]) {
            chunked[chunkIndex] = []; // start a new chunk
        }
        chunked[chunkIndex].push(item);
        return chunked;
    }, []);
}
exports.chunk = chunk;
/**
 * Returns string with first character in upper case.
 */
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
exports.capitalize = capitalize;
/**
 * Returns unique values from array.
 */
function unique(array) {
    return [...new Set(array)];
}
exports.unique = unique;
//# sourceMappingURL=utils.js.map